import { Field, reduxForm } from 'redux-form';
import { LoginButton, LoginButtonDisabled } from '../../components/buttons';
import { loginAction, logoutAction } from './actions/LoginActions';
import React, { Component } from 'react';
import { isValidName, renderTextField } from '../../components/reduxFields';
import { connect } from 'react-redux';
import LoginLogo from '../../img/loginlogo.png';
import { NavLink } from 'react-router-dom';
import validate from './validate';
import Favicon from 'react-favicon';

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errorMessage: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errorMessage && this.props.errorMessage !== nextProps.errorMessage) {
      let errorMessage = nextProps.errorMessage;
      this.setState({ errorMessage: errorMessage });
    }
  }

  onSubmit(authData) {
    console.log('LoginData---', authData);
    this.props.loginAction(authData);
  }

  render() {
    const { authenticatingToken } = this.props;
    if (authenticatingToken) {
      return (
        <div className="login_bg">
          <div className="login-wrapper">
            <div className="login-fields">
            Loading...Please wait !
            </div>
          </div>
        </div>);
    }
    return (
      <div className="login_bg_WithGradient">
        <div className="login-wrapper">
          <div className="login-fields">
            <Favicon url={this.props.organizationDetails && this.props.organizationDetails.favicon ? this.props.organizationDetails.favicon : ''} />
            <div className="loginlogo">
              {this.props.organizationDetails && this.props.organizationDetails.logoBase64 ?
                <img src={'data:image/png;base64,' + this.props.organizationDetails.logoBase64} alt="" />
                :
                <img src={LoginLogo} alt="" />}
            </div>
            <Field
              name="userName"
              type="text"
              normalize = {isValidName}
              maxLength="60"
              label="User Name or Email"
              component={renderTextField} />
            <Field
              name="password"
              type="password"
              maxLength="30"
              label="Password"
              component={renderTextField}/>
            <Field
              name="confirm_password"
              type="password"
              maxLength="30"
              label="Confirm password"
              component={renderTextField}/>
            {/* <TextField
                id="pass"
                floatingLabelText="Password"
                fullWidth={true}

            />
            <AutoComplete
              className="mt-20"
              hintText="Role"
              searchText={this.state.searchText}
              onUpdateInput={this.handleUpdateInput}
              onNewRequest={this.handleNewRequest}
              dataSource={colors}
              filter={(searchText, key) => (key.indexOf(searchText) !== -1)}
              openOnFocus={true}
              fullWidth={true}
            />*/}
            <div className="pt20">
              {/* <RaisedButton onClick={this.onSubmit} label="Register Now" primary={true} fullWidth={true}/>*/}
              {this.props.authenticating ? <LoginButtonDisabled /> : <LoginButton />}
            </div>
            <div className="createnew">
              Already have an account? <NavLink exact to="/login">Sign In</NavLink>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    authenticating: state.login.authenticating,
    authenticatingToken: state.login.authenticatingToken,
    errorMessage: state.login.errorMessage,
    organizationDetails: state.login.organizationDetails,
  };
}

Login = reduxForm({
  form: 'loginForm',
  validate,
  enableReinitialize: true, // this is needed!!
})(Login);

export default connect(mapStateToProps, { loginAction, logoutAction })(Login);



// WEBPACK FOOTER //
// ./src/modules/logins/register.js